/** Fired after customer/billing profile is saved so shell UI can re-fetch (e.g. billing banner in Layout). */
export const CUSTOMER_INFO_UPDATED_EVENT = 'effimetic-customer-info-updated';
